export default [
  {
    path: '/',
    name: 'Home',
    meta: { layout: 'side-nav' },
    component: r => require(['@/pages/index'], r)
  },
  {
    path: '/about',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'About',
        meta: { layout: 'default' },
        component: r => require(['@/pages/about/index'], r)
      }
    ]
  },
  {
    path: '/notifications',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Notifications',
        meta: { layout: 'default' },
        component: r => require(['@/pages/notifications/index'], r)
      }
    ]
  },
  {
    path: '/widgetdemo',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Widget Demo',
        meta: { layout: 'default' },
        component: r => require(['@/pages/widgetdemo/index'], r)
      }
    ]
  },
  {
    path: '/onboard/:id',
    meta: { allowAnonymous: true },
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Onboard',
        meta: { layout: 'no-nav' },
        component(r) {
          require(['@/pages/onboard/index'], r)
        }
      }
    ]
  },
  {
    path: '/brands',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Brands',
        meta: { layout: 'default' },
        component: r => require(['@/pages/brands/index'], r)
      }
    ]
  },
  {
    path: '/contacts',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Contacts',
        meta: { layout: 'default' },
        component: r => require(['@/pages/contacts/index'], r)
      }
    ]
  },
  {
    path: '/fleet',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Fleet',
        meta: { layout: 'default' },
        component: r => require(['@/pages/fleet/index'], r)
      }
    ]
  },
  {
    path: '/insurance',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Insurance',
        meta: { layout: 'default' },
        component: r => require(['@/pages/insurance/index'], r)
      }
    ]
  },
  {
    path: '/dashboard',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Dashboard',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/dashboard/index'], r)
        }
      }
    ]
  },
  {
    path: '/locations',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Locations',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/locations/index'], r)
        }
      }
    ]
  },
  {
    path: '/schedule',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Schedule',
        meta: { layout: 'default' },
        component: r => require(['@/pages/schedule/index'], r)
      }
    ]
  },
  {
    path: '/calibrates',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Calibrates',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/calibrates/index'], r)
        }
      }
    ]
  },
  {
    path: '/calibrates/:status',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'CalibratesStatus',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/calibrates/index'], r)
        }
      }
    ]
  },
  {
    path: '/calibrate/:calibrate/:calibrateEvent',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'CalibrateRequest',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/calibrates/request'], r)
        }
      }
    ]
  },
  {
    path: '/tech-requests',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'TechRequests',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/calibrates/main-tech-requests'], r)
        }
      }
    ]
  },
  {
    path: '/location-requests',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'LocationRequests',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/calibrates/location-requests'], r)
        }
      }
    ]
  },
  {
    path: '/dispatch',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Dispatch',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/dispatch/index'], r)
        }
      }
    ]
  },
  {
    path: '/techschedule',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Tech Schedule',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/dispatch/schedule'], r)
        }
      }
    ]
  },
  {
    path: '/admin',
    name: 'Administration',
    meta: { layout: 'side-nav' },
    component: r => require(['@/pages/admin/index'], r)
  },
  {
    path: '/configuration',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Configuration Settings',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/admin/configuration/index'], r)
        }
      }
    ]
  },
  {
    path: '/data',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Import/Export Facility',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/admin/import-data/index'], r)
        }
      }
    ]
  },
  {
    path: '/users',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Users',
        meta: { layout: 'default' },
        component: r => require(['@/pages/users/index'], r)
      }
    ]
  },
  {
    path: '/storage',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Storage',
        meta: { layout: 'default' },
        component: r => require(['@/pages/storage/index'], r)
      }
    ]
  },
  {
    path: '/chat',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Chat',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/chat/index'], r)
        }
      }
    ]
  },
  {
    path: '/chatadmin',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Chat Admin',
        meta: { layout: 'default' },
        component(r) {
          require(['@/pages/chat/admin'], r)
        }
      }
    ]
  },
  {
    path: '/blueprint',
    name: 'Request',
    meta: { allowAnonymous: true },
    component: (r) => require(['@/pages/calibrates/blueprint-request'], r)
  },
  {
    path: '/authorize/:calibrateEvent/:action/:token',
    name: 'Authorize',
    meta: { allowAnonymous: true },
    component: r => require(['@/pages/calibrates/authorize'], r)
  },
  {
    path: '/authorizeservices/:calibrateEvent/:action',
    name: 'AuthorizeServices',
    component: r => require(['@/pages/calibrates/authorize'], r)
  },
  {
    path: '/login',
    name: 'Login',
    meta: { allowAnonymous: true },
    component: r => require(['@/pages/login/index'], r)
  },
  {
    path: '/reset',
    name: 'Reset Password',
    meta: { allowAnonymous: true },
    component: r => require(['@/pages/login/reset'], r)
  },
  {
    path: '*',
    name: 'Page not Found',
    component: r => require(['@/pages/errors/error-404'], r)
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js